import styled from '@emotion/styled/macro';

export const DataTableContainer = styled.div((props) => ({
  [props.theme.breakpoints.up('xl')]: {
    '& [data-column]': {
      width: '33.3%',
    },
  },
}));
